import React, { useCallback } from 'react';

import { Formik } from 'formik';
import type { FormikProps } from 'formik';
import type { SuspendFilter } from 'v2/interfaces/reports/suspend';
import { suspendService, initialFilter } from 'v2/services/reports/suspend';

import Form from './Form';
import { FilterSchema } from './validations';

export function Filter() {
  const onSubmit = useCallback((values: SuspendFilter, { setSubmitting }: FormikProps<SuspendFilter>) => {
    suspendService.setFilter(values);
    setSubmitting(false);
  }, []);

  return (
    <Formik initialValues={initialFilter} validationSchema={FilterSchema} onSubmit={onSubmit}>
      <Form />
    </Formik>
  );
}
